<template>
  <b-modal
    v-model="visible"
    @ok="procesarCambio"
    @cancel="cerrar"
    @hide="cerrar"
    no-close-on-backdrop
    ok-title="Cambiar sede"
    cancel-title="Cancelar"
    title="Cambiar sede"
  >
    <label for="nueva-sede">Nueva sede</label>
    <select id="nueva-sede" v-if="sedesPosibles" v-model="nuevaSede" class="form-control">
      <option disabled value="">---SIN SEDE---</option>
      <option v-for="sede in sedesPosibles" :key="sede.id" :value="sede.id">{{ sede.nombre }}</option>
    </select>
  </b-modal>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import Vue from 'vue';

export default {
  name: 'CambiarSedeModal',
  data() {
    return {
      nuevaSede: '',
      visible: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      todasLasSedes: state => state.sedes.lista
    }),
    sedesPosibles() {
      if (!this.user || !this.user.data || !this.user.data.sedes_permitidas) {
        return []
      }
      return this.todasLasSedes.filter(sede => this.user.data.sedes_permitidas.includes(sede.id))
    }
  },
  methods: {
    ...mapActions({
      fetchSedes: 'sedes/fetchLista',
      logout: 'auth/logout',
      setWarning: 'setWarning'
    }),
    ...mapMutations({
      startProcessing: 'startProcessing',
      stopProcessing: 'stopProcessing'
    }),
    abrir() {
      this.nuevaSede = ''
      this.fetchSedes().then(() => {
        this.visible = true
      }).catch(error => {
        this.setWarning(error)
      })
    },
    procesarCambio(event) {
      if (!this.nuevaSede) {
        event.preventDefault()
        return
      }

      this.startProcessing()
      Vue.http.post('cambiarme_sede', { sede_id: this.nuevaSede })
        .then(() => this.logout())
        .then(() => this.$router.push('/login'))
        .catch(error => {
          this.setWarning(error)
        }).finally(() => {
          this.stopProcessing()
        })
    },
    cerrar() {
      this.nuevaSede = ''
      this.visible = false
    }
  }
}
</script>